<template>
  <div class="accessIndex">

    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg5 class="head_contain">
            <p class="table_card__head--title">
              Estudiantes
            </p>
          </v-flex>
          <v-flex xs12 lg7 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
               @click="editItem()"
              >
                Crear nuevo estudiante
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="pagination_query=false;getStudents();"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div>
        <div class="user__container--class_table_separator">
          <v-data-table
            :headers="headers"
            :items="students"
            hide-actions
            class="elevation-1 ">
            <template
              slot="items"
              slot-scope="props" >
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.rut }}</td>
              <td>{{ props.item.redeemed }}</td>
            </template>
          </v-data-table>
        </div>
        <div v-if="students.length>0 && pages > 1" class="accessIndex__pagination">
          <v-pagination  color="light-blue darken-3" v-model="pagination.page" :length="pages"></v-pagination>
          <label class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
          <label class="accessIndex__pagination--current_text" v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}</label>
          <label class="accessIndex__pagination--current_text" v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
        </div>
        <v-dialog v-model="modal_details" max-width="424px">
          <!-- <v-btn slot="activator" color="primary" dark class="mb-2">New Item</v-btn> -->
          <v-card style="border-radius: 10px;">
            <v-card-title style="border-bottom: 1px solid #E9E9F0">
              <span class="">Escriba el correo o rut (sin guiones) del estudiante y la clase</span>
            </v-card-title>
            <v-card-text style="padding: 0">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      name="key"
                      type="text"
                      label="RUT o email"
                      required
                      v-model="new_student_key">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-flex xs12>
                  <v-select
                    v-model="class_id"
                    :items="classes"
                    item-text="title"
                    item-value="id"
                    label="Clase"
                    single-line
                  ></v-select>
                </v-flex>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="grey lighten-1"
                flat
                @click.native="close()">Cerrar</v-btn>
              <v-btn
                color="light-blue darken-1"
                :disabled="new_student_key=='' || class_id==''"
                flat
                @click.native="addToClass()">Buscar y agregar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar
          v-model="snackbar.show"
          color="#0f9914"
          :multi-line="snackbar.mode === 'multi-line'"
          :timeout="snackbar.timeout"
          :vertical="snackbar.mode === 'vertical'"
        >
          {{ snackbar.text }}
          <v-btn
            dark
            flat
            @click="snackbar.show = false"
          >
            Cerrar
          </v-btn>
        </v-snackbar>
      </div>
    </div>
    <!-- <v-layout
      row>
      <v-flex xs4>
        <h1>Estudiantes con clases</h1>
      </v-flex>
      <v-flex xs3 offset-xs5>
        <v-btn
          style="width: 100%;"
          color="#EC7E00"
          @click="editItem()">Nuevo estudiante</v-btn>
      </v-flex>
    </v-layout> -->
    <!-- <div>
      <v-breadcrumbs>
        <v-icon slot="divider">chevron_right</v-icon>
        <v-breadcrumbs-item>
          <b style="color:#353545">Estudiantes</b>
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </div> -->
    
  </div>

</template>

<script>
export default {
  data () {
    return {
      pagination_query:false,
      pages:2,
      pagination: {page:1,rowsPerPage:24},
      invitations_size:0,
      modal_details: false,
      students: [],
      class_id: '',
      snackbar:{
        show: false,
        y: 'top',
        x: null,
        mode: '',
        timeout: 6000,
        text: 'Usuario añadido exitosamente'
      },
      headers: [
          { text: 'Nombre', sortable: true, value: 'name' },
          { text: 'Email', value: 'email', sortable: true },
          { text: 'RUT', value: 'rut', sortable: true },
          { text: 'Asistencias', value: 'assistances', sortable: true },
      ],
      classes: [],
      new_student_key:'',
      editedItem: {
        attributes:{
          title:'',
          message: '',
          users: [],
          send_date_time: null
        }
      },
      defaultItem: {
        attributes:{
          title:'',
          message: '',
          users: [],
          send_date_time: null
        }
      },
      editedIndex: -1
    }
  },
  mounted(){
    this.getStudents();
  },
   watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
        else if(oldVal!=val&&val!=null&&oldVal!=null){
          this.pagination_query=true;
           this.getStudents();
         }
       }
    },
  methods: {
    getStudents(){
      if(!this.pagination_query){
        this.pagination.page=1;
      }
      try {
        this.$http.get('classes/index_students',{
          params:{
            page:this.pagination.page
          },
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          this.students = response.body.data.students;
          this.classes = response.body.data.classes;
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    addToClass() {
      try {
        this.$http.post('classes/add_class_to_user',{
          data: this.encrypt({offer_id:this.class_id, user_key:this.new_student_key, all_students:true}).toString()
        },{
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }
        }).then(function(response){
          this.modal_details = false;
          this.snackbar.show = true;
          this.new_student_key ='';
          this.pagination_query=false;
          this.getStudents();
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          alert(response.body.errors[0].details);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    editItem (item) {
      this.modal_details = true
    },
    close () {
      this.class_id='';
      this.modal_details = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/classes/Index_students.vue